import { render, staticRenderFns } from "./Transporters.vue?vue&type=template&id=1b25efea"
import script from "./Transporters.vue?vue&type=script&lang=js"
export * from "./Transporters.vue?vue&type=script&lang=js"
import style0 from "./Transporters.vue?vue&type=style&index=0&id=1b25efea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports